import { RENDER_STATE } from "react-map-gl-draw";

export const getEditHandleStyle = ({ feature, state }) => {
  switch (state) {
    case RENDER_STATE.SELECTED:
    case RENDER_STATE.HOVERED:
    case RENDER_STATE.UNCOMMITTED:
      return {
        fill: '#FFF',
        fillOpacity: 0.6,
        stroke: '#ff0000',
        strokeWidth: 3,
        r: 7
      };

    default:
      return {
        fill: '#FFF',
        fillOpacity: 1,
        stroke: '#000000',
        strokeWidth: 3,
        r: 6
      };
  }
}

export const getFeatureStyle = ({ feature, index, state }) => {
  switch (state) {
    case RENDER_STATE.SELECTED:
    case RENDER_STATE.HOVERED:
    case RENDER_STATE.UNCOMMITTED:
    case RENDER_STATE.CLOSING:
      return {
        stroke: '#007bff',
        strokeWidth: 4,
        fill: '#ced4df',
        fillOpacity: 0.3
      };

    default:
      return {
        stroke: '#007bff',
        strokeWidth: 2,
        fill: '#FFF',
        fillOpacity: 0.2
      };
  }
}